import { HostBinding, Component, Input, TemplateRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: `suka-avatar`,
  template: `
    <ng-container *ngIf="!imgSrc">{{getInitials()}}</ng-container>
    <img *ngIf="imgSrc" [src]="imgSrc" />
  `
})
export class Avatar {
  /**
   * Sets an image url for the avatar. If it is set, it displays instead of the name initials.
   */
  @Input() imgSrc: string;

  /**
   * Avatar name. Used to display its initials (Max 2).
   */
  @Input() name: string;

  /**
   * Sets the avatar color.
   */
  @Input() color: 'blue' | 'azure' | 'indigo' | 'purple' | 'pink' | 'red' | 'orange' |
  'yellow' | 'lime' | 'green' | 'teal' | 'cyan' | 'gray' | 'gray-dark' = 'gray';

  /**
   * Sets the avatar class
   */
  @Input() class = '';

  /**
   * Sets the avatar size.
   */
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | '2xl' = 'md';

  @HostBinding('attr.class') get attrClass() {
    return `avatar avatar--${this.color} avatar--${this.size} ${this.class}`;
  }

  /**
   * Sets the avatar initials according to the name input.
   */
  getInitials(): string {
    if (this.name === '' || !this.name) {
      return '';
    }

    const names = this.name.split(' ');
    let initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  }
}
